import * as types from './action-types';
import { beginApiCall, apiCallError } from './api-status-actions';
import { formatAnalyticsData, formatDatesToFilter } from './utils/data-format-utils';
import * as analyticsApi from '../api/analytics-api';

export function loadAnalyticsAppDataSuccess(analytics) {
    return { type: types.LOAD_ANALYTICS_APP_DATA_SUCCESS, analytics };
}

export function loadAnalyticsAppDataError() {
    return { type: types.LOAD_ANALYTICS_APP_DATA_ERROR };
}

export function loadAnalyticsAppData(callBackUrl) {
    return function (dispatch) {
        dispatch(beginApiCall());
        return analyticsApi.loadAnalyticsAppData(callBackUrl)
            .then((response) => {
                if (response.hasErrors) {
                    dispatch(apiCallError([response.errorMessage]));
                    dispatch(loadAnalyticsAppDataError());
                    return;
                }

                dispatch(loadAnalyticsAppDataSuccess({
                    formattedAnalyticsData: formatAnalyticsData(response.data.data),
                    datesToFilter: formatDatesToFilter(response.data.dateToFilter)
                }));
            })
            .catch((error) => {
                dispatch(apiCallError([error]));
                dispatch(loadAnalyticsAppDataError());

                throw error;
            });
    };
}
